export default "__VITE_ASSET__DhWHr6Hl__"